import React from 'react';
import { classNames, GlobalBaseTheme, Spinner, useTheme } from '@groma-dev/blueprint';
import { observer } from 'mobx-react-lite';
import styles from './Loading.module.scss';

export interface LoadingProps {
  color?: string;
  height?: string;
  isPage?: boolean;
}

const Loading = observer((props: LoadingProps) => {
  const theme = useTheme();
  const isDarkTheme = theme.__base === GlobalBaseTheme.DARK;

  const {
    color = isDarkTheme ? theme.colors.$secondary300 : theme.colors.$primary300,
    height = '50px',
    isPage = false,
  } = props;

  return (
    <div className={classNames(styles.mainContainer, isPage && styles.fullPage)}>
      <div style={{ height }}>
        <Spinner color={color} />
      </div>
    </div>
  );
});

export default Loading;
